export enum ProfileGroupUserFlagValueEnum {
  organization = 4,
  district = 2,
  association = 1,
}
